{{#if item.enabled}}
  <li data-id="{{item.id}}" class="list-item btn">
    <h3>{{item.code}} - {{item.name}}</h3>
  </li>
{{/if}}
